// extracted by mini-css-extract-plugin
export default {"mobile_header":"CampaignHeader_mobile_header__mzQF7"};